import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class TradingSessionsService {
    constructor(private http: HttpClient) {}

    list(request: ListTradingSessionsRequest): Observable<ListTradingSessionsResponse> {
        return this.http.post<ListTradingSessionsResponse>("/trading-sessions", request);
    }

    listEntries(tradingSessionId: string): Observable<TradingSessionEntry[]> {
        return this.http.get<TradingSessionEntry[]>(`/trading-sessions/${tradingSessionId}/entries`);
    }

    getEntryLogs(tradingSessionId: string, tradingSessionEntryId: string): Observable<Blob> {
        return this.http.get(`/trading-sessions/${tradingSessionId}/entries/${tradingSessionEntryId}/logs`, {
            responseType: "blob",
        });
    }

    getSessionLogs(tradingSessionId: string): Observable<Blob> {
        return this.http.get(`/trading-sessions/${tradingSessionId}/logs`, { responseType: "blob" });
    }
}

export type ListTradingSessionsRequest = {
    page: number;
    itemsPerPage: number;
    startDate?: string | null | undefined;
    endDate?: string | null | undefined;
    scheduleTypes?: number[];
    userId?: string;
    userName?: string;
    botId?: string;
    botName?: string;
    returnEmptySessions?: boolean;
};

export type ListTradingSessionsResponse = {
    total: number;
    tradingSessions: TradingSession[];
};

export type TradingSession = {
    id: string;
    scheduledStartAtUtc: string;
    startedAtUtc: string;
    endedAtUtc: string;
    isFuture: boolean;
    schedules: string[];
    bots: string[];
};

export type TradingSessionEntry = {
    id: string;
    start: string;
    end: string | null | undefined;
    botId: string | null | undefined;
    purchasedStocks: number;
    soldStocks: number;
    userEmail: string | null | undefined;
    botName: string | null | undefined;
};
